import { Suspense, lazy } from "react";
// components
import LoadingScreen from "../components/loading-screen";

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

export const LoginPage = Loadable(lazy(() => import("../pages/LoginPage")));
export const LandingPage = Loadable(lazy(() => import("../pages/LandingPage")));
export const Page404 = Loadable(lazy(() => import("../pages/Page404")));

// TODO: contents

// TODO: blogs
export const BlogList = Loadable(
  lazy(() => import("../pages/contents/BlogList"))
);

export const CreateBlog = Loadable(
  lazy(() => import("../pages/contents/CreateBlog"))
);

export const ViewEditBlog = Loadable(
  lazy(() => import("../pages/contents/ViewEditBlog"))
);

// TODO: caterings
export const CateringList = Loadable(
  lazy(() => import("../pages/Catering/CateringList"))
);

export const CreateCatering = Loadable(
  lazy(() => import("../pages/Catering/CreateCatering"))
);

export const ViewEditCatering = Loadable(
  lazy(() => import("../pages/Catering/ViewEditCatering"))
);

export const CateringFormData = Loadable(
  lazy(() => import("../pages/Catering/CateringFormData"))
);

// TODO: entries

// TODO: galleries
export const GalleryList = Loadable(
  lazy(() => import("../pages/Entries/Galleries/GalleryList"))
);

export const CreateGallery = Loadable(
  lazy(() => import("../pages/Entries/Galleries/CreateGallery"))
);

export const ViewEditGallery = Loadable(
  lazy(() => import("../pages/Entries/Galleries/ViewEditGallery"))
);

// TODO: categories
export const CategoryList = Loadable(
  lazy(() => import("../pages/Entries/Categories/CategoryList"))
);

export const CreateCategory = Loadable(
  lazy(() => import("../pages/Entries/Categories/CreateCategory"))
);

export const ViewEditCategory = Loadable(
  lazy(() => import("../pages/Entries/Categories/ViewEditCategory"))
);

export const AssignPrinter = Loadable(
  lazy(() => import("../pages/Entries/Categories/AssignPrinter"))
);

// TODO: products
export const ProductList = Loadable(
  lazy(() => import("../pages/Products/ProductsList"))
);

export const CreateProduct = Loadable(
  lazy(() => import("../pages/Products/CreateProducts"))
);

export const ViewEditProduct = Loadable(
  lazy(() => import("../pages/Products/ViewEditProduct"))
);

// TODO: orders
export const OrderList = Loadable(
  lazy(() => import("../pages/Orders/OrdersList"))
);

export const CreateOrder = Loadable(
  lazy(() => import("../pages/Orders/CreateOrder"))
);

export const ViewEditOrder = Loadable(
  lazy(() => import("../pages/Orders/ViewEditOrder"))
);

export const CalendarOrders = Loadable(
  lazy(() => import("../pages/Orders/CalendarOrders"))
);

// TODO: contacts
export const ContactList = Loadable(
  lazy(() => import("../pages/Contacts/ContactList"))
);

export const CreateContact = Loadable(
  lazy(() => import("../pages/Contacts/CreateContact"))
);

// TODO: users
export const UserList = Loadable(
  lazy(() => import("../pages/Users/UsersList"))
);

export const CreateUser = Loadable(
  lazy(() => import("../pages/Users/CreateUser"))
);

// TODO: faqs
export const FaqList = Loadable(
  lazy(() => import("../pages/manage/faq/FaqList"))
);

export const CreateFaq = Loadable(
  lazy(() => import("../pages/manage/faq/CreateFaq"))
);

// TODO: notices
export const NoticeList = Loadable(
  lazy(() => import("../pages/Notices/NoticeList"))
);

export const CreateNotice = Loadable(
  lazy(() => import("../pages/Notices/CreateNotice"))
);

export const ViewEditNotice = Loadable(
  lazy(() => import("../pages/Notices/ViewEditNotice"))
);

// TODO: pos
export const POSPage = Loadable(lazy(() => import("../pages/POS/POSPage")));

// TODO: promo codes
export const PromoCodeList = Loadable(
  lazy(() => import("../pages/PromoCodes/PromoCodeList"))
);

export const PromoCodeUsagePage = Loadable(
  lazy(() => import("../pages/PromoCodes/PromoCodeUsagePage"))
);

// TODO: tags
export const TagsList = Loadable(lazy(() => import("../pages/Tag/TagsList")));

export const CreateTag = Loadable(lazy(() => import("../pages/Tag/CreateTag")));

export const ViewEditTag = Loadable(
  lazy(() => import("../pages/Tag/ViewEditTag"))
);

// TODO: riders
export const RiderList = Loadable(
  lazy(() => import("../pages/Rider/RidersList"))
);

export const CreateRider = Loadable(
  lazy(() => import("../pages/Rider/CreateRider"))
);

// TODO: crm orders
export const OrderKanban = Loadable(
  lazy(() => import("../pages/crmorders/index"))
);

// notification
export const Notification = Loadable(
  lazy(() => import("../sections/general/SendNotificationForm"))
);

// stock histories
export const StockHistories = Loadable(
  lazy(() => import("../pages/StockHistories/StockHistories.jsx"))
);

// TODO: pages
export const PageList = Loadable(
  lazy(() => import("../pages/Meta/Pages/PageList"))
);

export const CreatePage = Loadable(
  lazy(() => import("../pages/Meta/Pages/CreatePage"))
);

export const ViewEditPage = Loadable(
  lazy(() => import("../pages/Meta/Pages/ViewEditPage"))
);

export const SitemapPage = Loadable(
  lazy(() => import("../pages/Meta/Sitemap/SitemapPage"))
);

// activity logs
export const ActivityLogList = Loadable(
  lazy(() => import("../pages/ActivityLogs/ActivityLogList"))
);

// settings
export const SettingsPage = Loadable(
  lazy(() => import("../pages/Settings/SettingsPage"))
);

export const CartModalPage = Loadable(
  lazy(() => import("../pages/Settings/CartModalPage"))
);
